import AppConfig from '../utils/AppConfig';
import AppService from '../utils/AppService';
export var useAperzaUser = function (_a) {
    var _b, _c, _d;
    var _e = _a === void 0 ? {} : _a, user = _e.user, serviceType = _e.serviceType, _f = _e.notifications, notifications = _f === void 0 ? [] : _f, unreadMessageCount = _e.unreadMessageCount;
    // Migrate from `packages/aperza-api/src/domain/User.ts` isLogin()
    var isLogin = !!(user === null || user === void 0 ? void 0 : user.userId) && (user === null || user === void 0 ? void 0 : user.userId) !== -1;
    // Migrate from `packages/aperza-api/src/domain/User.ts` isBusiness()
    var isBusiness = !!((user === null || user === void 0 ? void 0 : user.buyer) && ((_b = user === null || user === void 0 ? void 0 : user.buyer) === null || _b === void 0 ? void 0 : _b.approvalFlag));
    // Migrate from `packages/aperza-api/src/domain/User.ts` isActiveBusiness()
    // * null check - user.buyer!.approvalFlag! already checked in `isBusiness`
    var isActiveBusiness = isBusiness
        ? ['DATA_INCOMPLETE', 'UNAPPLIED'].indexOf(user.buyer.approvalFlag) === -1
        : false;
    // * null check - user.buyer!.approvalFlag! already checked in `isBusiness`
    var isActiveBusinessCart = isBusiness && ['DATA_INCOMPLETE'].indexOf(user.buyer.approvalFlag) === -1;
    // Have to add this since non-TV does not have photoUrl (in AcUser.photoUrl)
    var userPhotoUrl = (_c = user === null || user === void 0 ? void 0 : user.photoUrl) !== null && _c !== void 0 ? _c : (_d = user === null || user === void 0 ? void 0 : user.acUser) === null || _d === void 0 ? void 0 : _d.photoUrl;
    function signUpUrl() {
        switch (serviceType) {
            case AppConfig.APERZA_EC:
                return "".concat(AppService.orderServerHost(), "/member/index.html");
            case AppConfig.APERZA_TV:
                return "".concat(AppService.idServerHost(), "/signup/tv/register.html");
            default:
                return "".concat(AppService.idServerHost(), "/signup/register.html");
        }
    }
    function loginUrl() {
        var currentUrl = new URL(window.location.href);
        var serviceTypeSiteId = serviceType;
        if (currentUrl.pathname.startsWith('/login')) {
            return currentUrl.toString();
        }
        // id-web : CATALOG.return.url is not used, use APERZA_SEARCH.return.url + /catalog instead
        if (serviceType === AppConfig.APERZA_CATALOG) {
            serviceTypeSiteId = AppConfig.APERZA_SEARCH;
        }
        return "".concat(AppService.idServerHost(), "/login/").concat(serviceTypeSiteId, "/?rp=header&path=").concat(AppService.checkEncodedPath(serviceType));
    }
    function logoutUrl() {
        var serviceTypeSiteId = serviceType;
        // id-web : CATALOG.return.url is not used, use APERZA_SEARCH.return.url + /catalog instead
        if (serviceType === AppConfig.APERZA_CATALOG) {
            serviceTypeSiteId = AppConfig.APERZA_SEARCH;
        }
        return "".concat(AppService.idServerHost(), "/logout/").concat(serviceTypeSiteId, "?path=").concat(AppService.encodedPath(serviceType));
    }
    return {
        user: user,
        serviceType: serviceType,
        notifications: notifications,
        unreadMessageCount: unreadMessageCount,
        isLogin: isLogin,
        isBusiness: isBusiness,
        isActiveBusiness: isActiveBusiness,
        isActiveBusinessCart: isActiveBusinessCart,
        userPhotoUrl: userPhotoUrl,
        signUpUrl: signUpUrl,
        loginUrl: loginUrl,
        logoutUrl: logoutUrl,
    };
};
